import React, { Component } from "react";
import PropTypes from "prop-types";
import SubMenuCards from "./SubMenuCards";
import SubMenuList from "./SubMenuList";

export default class MegaMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedItem: false,
      items: props.items,
      openSub: false,
    };

    this.selectItem = this.selectItem.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
  }

  selectItem(item) {
    if (this.state.selectedItem !== item) {
      this.setState({ selectedItem: item });
    } else {
      this.setState({ selectedItem: false });
    }
  }

  closeMenu() {
    this.setState({ selectedItem: false });
  }

  redirectTo(href) {
    const splitURL = window.location.href.split("/");
    const baseURL = splitURL.slice(0, 3).join("/");
    window.location.href = baseURL + href;
  }

  render() {
    return (
      <div>
        <div className="shadow" style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className="container px-0">
            <div className="row no-gutters">
              <div className="col-12 col-md-10 offset-md-1">
                <div className="d-flex flex-row text-center justify-content-center align-items-stretch flex-stretch">
                  {this.state.items.map((item, index) => (
                    <div
                      style={{ maxWidth: 100 / this.state.items.length + "%" }}
                      key={index}
                      className={`pt-2 flex-grow-1 justify-content-start btn ws-wrap rounded-0 d-flex flex-column align-items-center fill-white hover-bg-light-gray ${
                        item === this.state.selectedItem
                          ? "bg-white fill-primary text-primary hover-text-primary hover-fill-primary"
                          : "hover-text-primary hover-fill-primary text-white"
                      } `}
                      // go to new page if its a link, otherwise set it as selected
                      onClick={(e) =>
                        item.href
                          ? this.redirectTo(item.href)
                          : this.selectItem(item)
                      }
                    >
                      {React.isValidElement(item.sub) ? (
                        item.sub
                      ) : item.sub ? (
                        <h6
                          className={`${
                            this.props.menuType === "list"
                              ? "d-none d-md-block"
                              : ""
                          } px-0 mx-auto`}
                          dangerouslySetInnerHTML={{ __html: item.sub }}
                        />
                      ) : null}
                      <h4
                        className={
                          this.props.menuType === "list"
                            ? "py-2 py-sm-0 pt-lg-2 ss-paragraph"
                            : ""
                        }
                      >
                        {/* {this.props.menuType === "list" ? (
                          item.title
                        ) : ( */}
                        {item.title}
                        {/* )} */}
                      </h4>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        {!this.state.selectedItem ? null : (
          <div className="container">
            {this.props.menuType === "list" ? (
              <SubMenuList
                item={this.state.selectedItem}
                hideMenuHandler={this.closeMenu}
              />
            ) : null}
            {this.props.menuType === "cards" ? (
              <SubMenuCards
                item={this.state.selectedItem}
                hideMenuHandler={this.closeMenu}
              />
            ) : null}
          </div>
        )}

        {/* only show the bg if theres a submenu to show */}
        {!this.state.selectedItem ||
        !(
          this.state.selectedItem.cards || this.state.selectedItem.links
        ) ? null : (
          <div className="layer-negative fixed-top fixed-bottom bg-dark opacity-faded" />
        )}
      </div>
    );
  }
}

/**
 * Defines the shape of data sent through for a "Card style" sub menu
 */
export const CardItemProps = PropTypes.shape({
  title: PropTypes.string,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      tagline: PropTypes.string,
      body: PropTypes.string,
      link: PropTypes.string,
      buttonText: PropTypes.string,
    })
  ),
});

/**
 * Defines the shape of data sent through for a "List style" sub menu
 */
export const ListItemProps = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string,
  img: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      destination: PropTypes.string,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.string,
          destination: PropTypes.string,
        })
      ),
    })
  ),
});

MegaMenu.propTypes = {
  menuType: PropTypes.oneOf(["cards", "list"]),
  items: PropTypes.arrayOf(PropTypes.oneOfType([CardItemProps, ListItemProps])),
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/MegaMenu/index.js